import { Stack } from 'expo-router';

export default function PortfolioDetailLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="properties/[propertyId]/index" />
      <Stack.Screen name="properties/[propertyId]/mortgage" />
    </Stack>
  );
}

